import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import { Provider } from "react-redux";
import App from "./App";
import store from "./modules/store";

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
        <App store={store}/>
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
